import React from 'react';
import Layout from '../components/Layout';
import ContactSection from '../components/ContactSection';
import '../styles/impressum-page.css';
import '../styles/page-layout.css';

const ImpressumPage: React.FC = () => {
  return (
    <Layout
      title="Impressum | StimmDigital - Rechtliche Hinweise"
      description="Impressum von StimmDigital - Kontaktinformationen und rechtliche Hinweise gemäß TMG"
      keywords="Impressum, Kontakt, Rechtlich, TMG, StimmDigital, Berlin, Henri Stimm"
      showBreadcrumbs={true}
    >
      <section className="wrapper">
        <div className="page-container">
          {/* Header */}
          <div className="page-header">
            <span className="section-title">Rechtliche Hinweise</span>
            <h1>Impressum</h1>
            <p>
              Angaben gemäß § 5 TMG (Telemediengesetz)
            </p>
          </div>

          {/* Impressum Content */}
          <div className="page-content-card">
            
            <h2 style={{ color: '#0A8370', marginTop: '0', marginBottom: '2rem', fontSize: '1.8rem' }}>
              Angaben gemäß § 5 TMG
            </h2>
            
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
              gap: '2rem', 
              marginBottom: '3rem',
              background: 'rgba(10, 131, 112, 0.1)',
              padding: '2rem',
              borderRadius: '0.75rem',
              border: '1px solid rgba(10, 131, 112, 0.2)'
            }}>
              <div>
                <h4 style={{ color: '#0A8370', marginBottom: '1rem', fontSize: '1.1rem' }}>
                  Betreiber der Website
                </h4>
                <p style={{ lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.9)', margin: '0' }}>
                  <strong style={{ color: '#E5EAEA' }}>Stimm Digital GmbH & Co. KG</strong><br />
                  Rheinstr. 2-3<br />
                  12159 Berlin
                </p>
                
                <h4 style={{ color: '#0A8370', marginTop: '1.5rem', marginBottom: '1rem', fontSize: '1.1rem' }}>
                  Vertreten durch
                </h4>
                <p style={{ lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.9)', margin: '0' }}>
                  Persönlich haftende Gesellschafterin:<br />
                  <strong>Stimm Digital Verwaltungsgesellschaft mbH</strong><br />
                  (Amtsgericht Berlin-Charlottenburg, HRB 281821)<br />
                  <br />
                  Diese vertreten durch den Geschäftsführer:<br />
                  Henri Stimm
                </p>
              </div>
              <div>
                <h4 style={{ color: '#0A8370', marginBottom: '1rem', fontSize: '1.1rem' }}>
                  Kontakt
                </h4>
                <p style={{ lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.9)', margin: '0' }}>
                  Telefon: <a href="tel:+493042141523" style={{ color: '#0A8370', textDecoration: 'none' }}>+49 30 42141523</a><br />
                  E-Mail: <a href="mailto:info@stimm.digital" style={{ color: '#0A8370', textDecoration: 'none' }}>info@stimm.digital</a><br />
                  Website: <span style={{ color: 'rgba(255, 255, 255, 0.9)' }}>stimm.digital</span>
                </p>

                <h4 style={{ color: '#0A8370', marginTop: '1.5rem', marginBottom: '1rem', fontSize: '1.1rem' }}>
                  Registereintrag
                </h4>
                <p style={{ lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.9)', margin: '0' }}>
                  Eintragung im Handelsregister.<br />
                  Registergericht: Amtsgericht Berlin-Charlottenburg<br />
                  Registernummer: HRA 65024 B
                </p>
              </div>
            </div>

            <h2 style={{ color: '#0A8370', marginBottom: '1.5rem', fontSize: '1.8rem' }}>
              Weitere Angaben
            </h2>
            
            <div style={{ 
              background: 'rgba(10, 131, 112, 0.1)', 
              padding: '2rem', 
              borderRadius: '0.75rem',
              border: '1px solid rgba(10, 131, 112, 0.2)',
              marginBottom: '3rem'
            }}>
              <h4 style={{ color: '#0A8370', marginBottom: '1rem', fontSize: '1.1rem' }}>
                Umsatzsteuer-ID
              </h4>
              <p style={{ fontSize: '1.1rem', color: '#E5EAEA', margin: '0 0 1.5rem 0' }}>
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                <strong>Wird vergeben</strong>
              </p>
              
              <h4 style={{ color: '#0A8370', marginBottom: '1rem', fontSize: '1.1rem' }}>
                Verantwortlich für den Inhalt
              </h4>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.6', margin: '0' }}>
                Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:<br />
                Henri Stimm<br />
                Rheinstr. 2-3<br />
                12159 Berlin
              </p>
            </div>

            <h2 style={{ color: '#0A8370', marginBottom: '1.5rem', fontSize: '1.8rem' }}>
              Haftung und Urheberrecht
            </h2>
            
            <h3 style={{ color: '#0A8370', marginBottom: '1rem', fontSize: '1.3rem', margin: '0 0 1rem 0', padding: '0' }}>
              Haftung für Inhalte
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '1.5rem', color: 'rgba(255, 255, 255, 0.9)' }}>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
            
            <h3 style={{ color: '#0A8370', marginBottom: '1rem', fontSize: '1.3rem', margin: '0 0 1rem 0', padding: '0' }}>
              Haftung für Links
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '1.5rem', color: 'rgba(255, 255, 255, 0.9)' }}>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>

            <h3 style={{ color: '#0A8370', marginBottom: '1rem', fontSize: '1.3rem', margin: '0 0 1rem 0', padding: '0' }}>
              Urheberrecht
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '3rem', color: 'rgba(255, 255, 255, 0.9)' }}>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>

            <h2 style={{ color: '#0A8370', marginBottom: '1.5rem', fontSize: '1.8rem' }}>
              Streitschlichtung
            </h2>
            
            <div style={{ 
              background: 'rgba(10, 131, 112, 0.1)', 
              padding: '2rem', 
              borderRadius: '0.75rem',
              marginBottom: '1.5rem',
              border: '1px solid rgba(10, 131, 112, 0.2)'
            }}>
              <p style={{ lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.9)', marginBottom: '1rem' }}>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" style={{ color: '#0A8370', textDecoration: 'none' }}>https://ec.europa.eu/consumers/odr</a>.<br />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
              <p style={{ lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.9)', margin: '0' }}>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </div>

          {/* Quick Contact Info */}
          <div style={{
            maxWidth: '600px',
            margin: '3rem auto 4rem auto',
            textAlign: 'center',
            padding: '2rem',
            background: 'linear-gradient(135deg, rgba(10, 131, 112, 0.1), rgba(10, 131, 112, 0.05))',
            borderRadius: '1rem',
            border: '1px solid rgba(10, 131, 112, 0.2)',
            backdropFilter: 'blur(10px)'
          }}>
            <h3 style={{ color: '#0A8370', marginBottom: '1rem', margin: '0 0 1rem 0', padding: '0' }}>
              Hast du Fragen?
            </h3>
            <p style={{ marginBottom: '1.5rem', lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.9)' }}>
              Kontaktiere uns gerne bei rechtlichen Fragen oder Anliegen zu diesem Impressum.
            </p>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '2rem', 
              flexWrap: 'wrap',
              fontSize: '0.9rem'
            }}>
              <a 
                href="mailto:info@stimm.digital" 
                style={{ 
                  color: '#0A8370', 
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  transition: 'color 0.3s ease'
                }}
              >
                info@stimm.digital
              </a>
              <a 
                href="tel:+493042141523" 
                style={{ 
                  color: '#0A8370', 
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  transition: 'color 0.3s ease'
                }}
              >
                +49 30 42141523
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <ContactSection />
    </Layout>
  );
};

export default ImpressumPage;
